import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

export type LoaderSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.html',
  styleUrl: './loader.scss',
})
export class Loader {
  message = input<string>('Loading...');

  // 'overlay' = covers the parent panel (e.g. Search Results / Case Actions card)
  // 'fullscreen' = covers the entire viewport (e.g. initial app boot)
  // 'inline' = sits in normal flow, no backdrop (e.g. inside a button or small panel)
  variant = input<'overlay' | 'fullscreen' | 'inline'>('overlay');

  size = input<LoaderSize>('md');
}
